<div class="row">
  <ng-content></ng-content>
  <div class="col-4 ml-auto">
    <div class="d-flex justify-content-end align-items-center ">
      <span style="margin-right: 40px;">Tổng {{total}} kết quả
      </span>
      <button nz-button nzType="primary" *ngIf="isSearch" (click)="search()">Tìm kiếm</button>
    </div>
  </div>
</div>